module.exports = __webpack_public_path__ + "media/src/img/urgent-sticker-f5b1e26d82c40dd079524f730974101e.png";